import { Controller } from "@hotwired/stimulus"

// Marks the time entry a shared link points at and scrolls it into view.
// Put it on the entry itself, or anywhere with
// data-highlight-target-id-value="<dom id>" to mark another element (the
// time page, where cards are rendered by a shared partial).
const CLASSES = ["ring-2", "ring-amber-400", "ring-offset-2", "ring-offset-white",
                 "dark:ring-amber-500", "dark:ring-offset-gray-900", "rounded-lg"]

export default class extends Controller {
  static values = { targetId: String }

  connect() {
    const el = this.targetIdValue ? document.getElementById(this.targetIdValue) : this.element
    if (!el) return

    el.classList.add(...CLASSES)
    requestAnimationFrame(() => el.scrollIntoView({ block: "center", behavior: "smooth" }))
  }
}
